import * as React from "react";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
// import LockResetIcon from "@mui/icons-material/LockReset";
import NoDataFound from "../../../shared/NoDataFound/NoDataFound";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import { decrypt } from "../../../utils/encryptDecrypt";
import { fDate } from "../../../utils/formatTime";
import CandidateInfoModal from "../CandidateInfoModal/CandidateInfoModal";
import { AuthContext } from "../../../context/AuthContext";
import { LoaderTable } from "../../../components/Loader/Loader";
import "../../../styles/Layout/Admin_Styles/_AdminTable.scss";
import ReUploadImageCroper from "../ReUploadImage/ReUploadImageCroper";

const rows = [];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    tableHead
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead className="admin-table--head">
      <TableRow>
        {tableHead?.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell?.alignItems}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {/* <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            > */}
            {headCell.label}
            {/* {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null} */}
            {/* </TableSortLabel> */}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

// function EnhancedTableToolbar(props) {
//   const { numSelected } = props;

//   return (
//     <Toolbar
//       sx={{
//         pl: { sm: 2 },
//         pr: { xs: 1, sm: 1 },
//         ...(numSelected > 0 && {
//           bgcolor: (theme) =>
//             alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
//         }),
//       }}
//     >
//       {numSelected > 0 ? (
//         <Typography
//           sx={{ flex: '1 1 100%' }}
//           color="inherit"
//           variant="subtitle1"
//           component="div"
//         >
//           {numSelected} selected
//         </Typography>
//       ) : (
//         <Typography
//           sx={{ flex: '1 1 100%' }}
//           variant="h6"
//           id="tableTitle"
//           component="div"
//         >
//           Nutrition
//         </Typography>
//       )}

//       {numSelected > 0 ? (
//         <Tooltip title="Delete">
//           <IconButton>
//             <DeleteIcon />
//           </IconButton>
//         </Tooltip>
//       ) : (
//         <Tooltip title="Filter list">
//           <IconButton>
//             <FilterListIcon />
//           </IconButton>
//         </Tooltip>
//       )}
//     </Toolbar>
//   );
// }

// EnhancedTableToolbar.propTypes = {
//   numSelected: PropTypes.number.isRequired,
// };

export default function EnhancedTable(_props) {
  const {
    tableHead,
    data,
    pageChangeHandler,
    paginationData,
    handleOpen,
    handleUpdate,
    actions = [],
    handleActions
  } = _props;
  const { isTableLoading, setAlertState } = React.useContext(AuthContext);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  // const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);

  // const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleAction = (type, id, name) => {
    handleActions(type, id, name)
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = data.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    pageChangeHandler(newPage);
    // setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    // setRowsPerPage(parseInt(event.target.value, 10));
    // setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    paginationData?.currentPage > 0
      ? Math.max(
        0,
        (1 + paginationData?.currentPage) * paginationData?.rowsPerPage -
        paginationData?.totalRecord
      )
      : 0;

  return (
    <Box sx={{ width: "100%" }} className="admin-table--box">
      <Paper sx={{ width: "100%", mb: 2 }}>
        {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={paginationData?.totalRecord}
              tableHead={tableHead}
            />
            <TableBody className="admin-table--body">
              {isTableLoading && (
                <TableCell colSpan={tableHead.length + 1}>
                  <LoaderTable />
                </TableCell>
              )}
              {!isTableLoading &&
                data?.length > 0 &&
                data?.map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  // const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleClick(event, row.id)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={index}
                      selected={isItemSelected}
                    >
                      {tableHead?.map((coloumn, index) => {
                        if (coloumn?.id !== "") {
                          if (coloumn?.decrypt) {
                            return (
                              <TableCell
                                key={coloumn?.id}
                                align={coloumn?.alignItems}
                              >
                                {row[coloumn?.id]
                                  ? decrypt(row[coloumn?.id])
                                  : "-"}
                              </TableCell>
                            );
                          }
                          if (coloumn?.isArray) {
                            return (
                              <TableCell
                                key={coloumn?.id}
                                align={coloumn?.alignItems}
                              >
                                {row[coloumn?.id].length > 0
                                  ? row[coloumn?.id]?.toString()
                                  : "-"}
                              </TableCell>
                            );
                          }
                          if (coloumn?.date) {
                            return (
                              <TableCell
                                key={coloumn?.id}
                                align={coloumn?.alignItems}
                              >
                                {row[coloumn?.id]
                                  ? fDate(row[coloumn?.id], coloumn.format)
                                  : "-"}
                              </TableCell>
                            );
                          }
                          if (coloumn?.status) {
                            return (
                              <TableCell
                                key={coloumn?.id}
                                align={coloumn?.alignItems}
                              >
                                {row[coloumn?.id] ? (
                                  <p className={row?.className}>
                                    {String(row[coloumn?.id])}
                                  </p>
                                ) : (
                                  "-"
                                )}
                              </TableCell>
                            );
                          }
                          if (coloumn?.link) {
                            return (
                              <TableCell
                                key={coloumn?.id}
                                className="table-link"
                                align={coloumn?.alignItems}
                                onClick={() => {
                                  handleOpen(row[coloumn?.id], coloumn?.type);
                                }}
                              >
                                {coloumn?.text ? (coloumn?.linkLabel) : (
                                  row[coloumn?.id]
                                    ? `${row[coloumn?.id]}`
                                    : "-")}

                              </TableCell>
                            );
                          }
                          if (coloumn?.reUploadImage) {
                            return (
                              <TableCell
                                key={coloumn?.id}
                                className="table-image"
                                align={coloumn?.alignItems}
                              >
                                <ReUploadImageCroper
                                  imageUrl={
                                    row[coloumn?.id]?.length > 0
                                      ? row[coloumn?.id]
                                      : null
                                  }
                                  handleUpdate={handleUpdate}
                                  userId={row?.id}
                                // refreshTable={()=>}
                                />
                              </TableCell>
                            );
                          }
                          if (coloumn?.action) {
                            return (
                              <TableCell
                                key={coloumn?.id}
                                align={coloumn?.alignItems}
                              >
                                {
                                  actions.map((action) => (
                                    <Tooltip key={action?.title} className={action?.className} title={action?.title} onClick={() => {
                                      if (row?.application_status === 2) {
                                        setAlertState((prev) => ({
                                          ...prev,
                                          open: true,
                                          title: "User Application has been cancelled.",
                                          btnTxt: "OK",
                                          status: "fail",
                                        }));
                                        return false
                                      }
                                      handleAction(action?.type, row?.id, row?.name)
                                    }}>
                                      <IconButton>
                                        {action?.icon}
                                      </IconButton>
                                    </Tooltip>
                                  ))}
                              </TableCell>
                            );
                          }
                          return (
                            <TableCell
                              key={coloumn?.id}
                              align={coloumn?.alignItems}
                            >
                              {coloumn?.id === "application_no"
                                ? `${row[coloumn?.id]}`
                                : row[coloumn?.id]
                                  ? row[coloumn?.id]
                                  : "-"}
                            </TableCell>
                          );
                        }
                      })}
                    </TableRow>
                  );
                })}
              {!isTableLoading && data?.length === 0 && (
                <TableCell colSpan={tableHead.length + 1}>
                  <NoDataFound />
                </TableCell>
              )}
              {/* {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )} */}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[paginationData?.rowsPerPage]}
          component="div"
          count={paginationData?.totalRecord}
          rowsPerPage={paginationData?.rowsPerPage}
          page={paginationData?.currentPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  );
}
